import { Facet } from '../models/Facet';
import { IBackgroundTaskQueue } from '../models/backgroundTasks/IBackgroundTaskQueue';
import { IOfflineCache } from '../operations/offlineCache';
import { KeyFacet, Key } from '../models/KeyFacet';

export const backgroundTaskQueueFacet: Facet<IBackgroundTaskQueue> = new Facet('backgroundTaskQueue');

export const errorHandlerFacet: Facet<(error: Error) => void> = new Facet('errorHandler');

export const offlineCacheFacet: Facet<IOfflineCache> = new Facet('offlineCache');

export const configurationItemKeyFacet: KeyFacet<{}> = new KeyFacet('configuration', {});

export const configurationItemKey: Key<{}> = configurationItemKeyFacet.serialize({});

/**
 * Configuration facet to set the current default locale, as a fallback for data sources
 * which do not supply their own data locale.
 */
export const localeFacet: Facet<{
  language: string;
}> = new Facet('locale');

/**
 * Configuration facet to control cache pruning defaults.
 */
export const pruningConfigurationFacet: Facet<{
  pageDuration?: number;
  maxAge?: number;
}> = new Facet('pruningConfiguration');

/**
 * Configuration facet to enable the File Hover Card feature in the Details and Tiles lists.
 * @public
 */
export const enableFileHoverCardConfigurationFacet = new Facet<boolean>('enableFileHoverCard');

/**
 * Configuration facet to enable the Shimmered Details List.
 * Default value is `true`.
 * @public
 */
export const enableShimmeredDetailsListConfigurationFacet = new Facet<boolean>('enableShimmeredDetailsList');

/**
 * Enable storage of larger backing items within [processResponse]
 * // TODO This needs to go in addon-sp
 */
export const enableSharePointBackingItemsFacet: Facet<boolean> = new Facet('enableSharePointBackingItems');

/**
 * Configuration facet to enable follow a Item feature in Details List.
 * @public
 */
export const enableFollowItemConfigurationFacet = new Facet<boolean>('enableFollowItem');

/**
 * Configuration facet to constrain the number of images loaded in parallel for items.
 * @beta
 */
export const maxParallelImageLoadCountFacet = new Facet<number>('maxParallelImageLoadCount');

/**
 * Controls whether or not to show item count for folders in the 'file size' column.
 */
export const enableItemCountInFileSizeColumnFacet = new Facet<boolean>('enableItemCountInFileSizeColumn');

/**
 * Configuration facet for enable persistent layout
 */
export const isItemsViewLayoutPersistenceEnableConfigurationFacet = new Facet<boolean>('enablePersistentLayout');
/**
 * Configuration facet for enabling Fluent Folder Cover layout
 */
export const enableFluentIconsFacet = new Facet<boolean>('enableFluentIcons');
/**
 * Configuration facet to enable trending analytics.
 * @public
 */
export const enableTrendingConfigurationFacet = new Facet<boolean>('enableTrending');
// DO NOT add configuration facets specific to add-ons. Only configure features here which are defined in Items View Core.
